module.exports = __webpack_public_path__ + "img/nmi-color.665ed71.webp";